/* eslint-disable react/prop-types */
import React from 'react';
import moment from 'moment';
import { Typography, TableContainer, Table, TableBody, TableCell, TableHead, TableRow } from '@applyboard/ui-components';
import { TableCellStyle, _DeadlineNote } from "./styles";
function renderTable(testId, title, deadline, visaRefusalDeadline, note) {
  var NO_CONTENT_TEXT = 'N/A';
  var formatDeadline = deadline && moment(deadline).format('YYYY-MMM-DD') || NO_CONTENT_TEXT;
  var formatVisaRefusalDeadline = visaRefusalDeadline && moment(visaRefusalDeadline).format('YYYY-MMM-DD') || NO_CONTENT_TEXT;
  var deadlineNote = typeof note === 'string' && note.length > 0 && note || NO_CONTENT_TEXT;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testId
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    mt: 2,
    mb: 2
  }, title), /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    style: TableCellStyle
  }, "All STUDENTS"), /*#__PURE__*/React.createElement(TableCell, {
    style: TableCellStyle
  }, "VISA REFUSAL"), /*#__PURE__*/React.createElement(TableCell, null, "NOTES"))), /*#__PURE__*/React.createElement(TableBody, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, formatDeadline), /*#__PURE__*/React.createElement(TableCell, null, formatVisaRefusalDeadline), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(_DeadlineNote, null, deadlineNote)))))));
}
var IntakeDealineDetails = function IntakeDealineDetails(_ref) {
  var programIntakeSupplementalInformation = _ref.programIntakeSupplementalInformation;
  var refundDeadline = programIntakeSupplementalInformation.refundDeadline,
    visaRefusalRefundDeadline = programIntakeSupplementalInformation.visaRefusalRefundDeadline,
    refundDeadlineNote = programIntakeSupplementalInformation.refundDeadlineNote,
    deferralDeadline = programIntakeSupplementalInformation.deferralDeadline,
    visaRefusalDeferralDeadline = programIntakeSupplementalInformation.visaRefusalDeferralDeadline,
    deferralDeadlineNote = programIntakeSupplementalInformation.deferralDeadlineNote;
  var showRefundDeadline = refundDeadline || visaRefusalRefundDeadline || refundDeadlineNote;
  var showDeferralDeadline = deferralDeadline || visaRefusalDeferralDeadline || deferralDeadlineNote;
  var showImportantDates = showRefundDeadline || showDeferralDeadline;
  if (!showImportantDates) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    gutterBottom: true
  }, "IMPORTANT DATES"), showRefundDeadline ? renderTable('refund-deadlines', 'Refund Deadlines', refundDeadline, visaRefusalRefundDeadline, refundDeadlineNote) : 'No refund deadline dates recorded', showDeferralDeadline ? renderTable('deferral-deadlines', 'Deferral Deadlines', deferralDeadline, visaRefusalDeferralDeadline, deferralDeadlineNote) : 'No deferral deadline dates recorded');
};
export default IntakeDealineDetails;